import { ICallbackAction } from "../config/user_payment_method_callback";

export const toForm = (data: ICallbackAction): ICallbackAction => {
    return {
        action: data.action,
        payload: JSON.stringify(data.payload),
    };
};
